export default __webpack_public_path__ + "static/media/website.06339c20.svg";